module.exports = __webpack_public_path__ + "static/media/container-003.7025daa3.jpg";